/***
 * Created on 2024/9/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useReducer} from 'react';
import ChinaAddPhoneStep1 from "./force_china_phone_dialog/china_add_phone_step_1";
import ChinaAddPhoneStep2 from "./force_china_phone_dialog/china_add_phone_step_2";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {I18nextProvider} from "react-i18next";
import sharedI18n from "common/SharedI18n";
import ChinaAddPhoneStep3 from "./force_china_phone_dialog/china_add_phone_step_3";

const initialState = {
    currentStep: 1
}

function reducer(state, action) {
    if (action.type === 'currentStep') {
        return {
            ...state,
            currentStep: action.value,
            inputValues: action.inputValues
        };
    }
    else return state;
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});


function ForceChinaPhone(props) {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <I18nextProvider i18n={sharedI18n} >
            <QueryClientProvider client={queryClient}>
                {state?.currentStep === 1 && <ChinaAddPhoneStep1 showModal={state?.currentStep === 1} state={state} dispatch={dispatch}/>}
                {state?.currentStep === 2 && <ChinaAddPhoneStep2 showModal={state?.currentStep === 2} state={state} dispatch={dispatch}/>}
                {state?.currentStep === 3 && <ChinaAddPhoneStep3 showModal={state?.currentStep === 3} state={state} dispatch={dispatch}/>}
            </QueryClientProvider>
        </I18nextProvider>
    );
}

export default ForceChinaPhone;